export enum CompanyType {
  UNKNOWN,
  PHYSICAL,
  LEGAL,
  PARTNERSHIP
};